import { render, staticRenderFns } from "./Tabber.vue?vue&type=template&id=978ff4c4"
import script from "./Tabber.vue?vue&type=script&lang=ts"
export * from "./Tabber.vue?vue&type=script&lang=ts"
import style0 from "./Tabber.vue?vue&type=style&index=0&id=978ff4c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports